import {CatalogId, Namespace, ProductName, ProductSlug} from '../../commonTypes';

export enum PurchaseTypes {
    AUTO_PURCHASE = 'AUTO_PURCHASE',
    REMOVE_AUTO_PURCHASE = 'REMOVE_AUTO_PURCHASE',
    PURCHASE = 'PURCHASE',
    PURCHASE_BEGIN = 'PURCHASE_BEGIN',
    PURCHASE_SUCCESS = 'PURCHASE_SUCCESS',
    PURCHASE_FAILURE = 'PURCHASE_FAILURE',
    SET_USER_DID_CLICK_PURCHASE = 'SET_USER_DID_CLICK_PURCHASE',
    SET_USER_DISMISSED_COMPATIBILITY_WARNING = 'SET_USER_DISMISSED_COMPATIBILITY_WARNING',
    SET_USERS_PLATFORM_IS_FULLY_SUPPORTED = 'SET_USERS_PLATFORM_IS_FULLY_SUPPORTED'
}

// @depreciated
export const TYPES = PurchaseTypes;

export interface CatalogIdPayload {
    id: CatalogId;
}

export interface PurchasePayload {
    namespace: Namespace;
    id: CatalogId;
    isLoggedIn: boolean;
    isLauncher: boolean;
    productName: ProductName;
    productSlug: ProductSlug;
}

export interface PurchaseSuccessPayload {
    namespace: Namespace;
    id: CatalogId;
    offerId: CatalogId;
}

export interface SetUserDidClickPurchasePayload {
    userDidClickPurchase: boolean;
    productName: string;
}

export interface SetUserDidDismissCompatibilityWarningPayload {
    userDidDismissCompatibilityWarning: boolean;
    productName: string;
}

export interface SetUsersPlatformIsFullySupportedPayload {
    usersPlatformIsFullySupported: boolean;
    productName: string;
}

export interface PurchaseAction {
    type: PurchaseTypes;
    payload?:
        | CatalogIdPayload
        | PurchasePayload
        | PurchaseSuccessPayload
        | SetUserDidClickPurchasePayload
        | SetUserDidDismissCompatibilityWarningPayload
        | SetUsersPlatformIsFullySupportedPayload;
}

export default {
    // @depreciated
    TYPES,

    setUsersPlatformIsFullySupported: (
        usersPlatformIsFullySupported: boolean,
        productName: string
    ): PurchaseAction => ({
        type: PurchaseTypes.SET_USERS_PLATFORM_IS_FULLY_SUPPORTED,
        payload: {usersPlatformIsFullySupported, productName}
    }),

    setUserDismissedCompatibilityWarning: (
        userDidDismissCompatibilityWarning: boolean,
        productName: string
    ): PurchaseAction => ({
        type: PurchaseTypes.SET_USER_DISMISSED_COMPATIBILITY_WARNING,
        payload: {userDidDismissCompatibilityWarning, productName}
    }),

    setUserDidClickPurchase: (
        userDidClickPurchase: boolean,
        productName: string
    ): PurchaseAction => ({
        type: PurchaseTypes.SET_USER_DID_CLICK_PURCHASE,
        payload: {userDidClickPurchase, productName}
    }),

    removeAutoPurchase: (): PurchaseAction => ({
        type: PurchaseTypes.REMOVE_AUTO_PURCHASE
    }),

    autoPurchase: (id: CatalogId): PurchaseAction => ({
        type: PurchaseTypes.AUTO_PURCHASE,
        payload: {id}
    }),

    purchase: (
        namespace: Namespace,
        id: CatalogId,
        productName: ProductName,
        productSlug: ProductSlug
    ): PurchaseAction => ({
        type: PurchaseTypes.PURCHASE,
        payload: {
            namespace,
            id,
            productName,
            productSlug
        }
    }),

    purchaseBegin: (id: CatalogId): PurchaseAction => ({
        type: PurchaseTypes.PURCHASE_BEGIN,
        payload: {id}
    }),

    purchaseSuccess: (namespace: Namespace, id: CatalogId): PurchaseAction => ({
        type: PurchaseTypes.PURCHASE_SUCCESS,
        payload: {namespace, id, offerId: id}
    }),

    purchaseFailure: (id: CatalogId): PurchaseAction => ({
        type: PurchaseTypes.PURCHASE_FAILURE,
        payload: {id}
    })
};
